export const REACT_API_BASE_URL = 'https://technotes-api.herokuapp.com';
export const REACT_API_VERSION = 'v1';

export const LS_KEY_NAME = '__app__loggedin__key__';

export const API_URL = `${REACT_API_BASE_URL}/api/${REACT_API_VERSION}`;
